<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Blog</h1>
      <div class="div-page-description"><h5>Dive into the world of SEO and Google indexing with our comprehensive collection of blog posts.</h5></div>
    </div>
    <div class="container">
      <div class="row">
        <app-spinner *ngIf="!blogPosts"></app-spinner>
        <div class="col-lg-4" *ngFor="let blogPost of blogPosts">
          <div class="card">
            <img loading="lazy" src="resources/{{blogPost.image}}" class="card-img-top" alt="...">
            <div class="card-body">
              <h5 class="card-title"><a [routerLink]="['/blog/'+blogPost.slug]" class="text-black">{{blogPost.title}}</a></h5>
              <div [innerHtml]="blogPost.content.split('. ', 1)[0]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
